import { DEVICE_TYPE } from '../../constants/commonConstants';
import getDeviceType from '../common/getDeviceType/getDeviceType';
import AndroidTvDeviceManager from './androidtv/AndroidTvDeviceManager';
import TizenDeviceManager from './tizen/TizenDeviceManager';
import WebDeviceManager from './web/WebDeviceManager';
import WebOSDeviceManager from './webos/WebOSDeviceManager';
var DeviceManagerInstance = (function () {
    switch (getDeviceType()) {
        case DEVICE_TYPE.ANDROIDTV: {
            return new AndroidTvDeviceManager();
        }
        case DEVICE_TYPE.TIZEN: {
            return new TizenDeviceManager();
        }
        case DEVICE_TYPE.WEBOS: {
            return new WebOSDeviceManager();
        }
        default:
            return new WebDeviceManager();
    }
})();
export default DeviceManagerInstance;
